import React, { useEffect, useRef, useState } from 'react'
// import {
//   Chart as ChartJS,
//   LinearScale,
//   CategoryScale,
//   BarElement,
//   PointElement,
//   LineElement,
//   Legend,
//   Tooltip,
// } from 'chart.js'
import { Chart } from 'react-chartjs-2'
import { useSelector } from 'react-redux'
import { deviseCal } from 'utils/helpers'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
let click = false

function LineBarGraph({ data, filters }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const siteDevise = useSelector((store) => store.devise)

  const optionsbar = {
    indexAxis: 'x',
    maintainAspectRatio: false,
    onClick: function (evt, element) {
      click = !click

      if (element[0] && click) {
        filters(data.yearMonths[element[0].index])
      } else if (click === false) {
        filters()
      }
    },
    // Elements options apply to all of the options unless overridden in a dataset
    // In this case, we are setting the border of each horizontal bar to be 2px wide
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    scales: {
      y: {
        ticks: {
          color: 'white',
        },
        grid: {
          display: true,
          color: 'rgba(255,99,132,0.2)',
          stacked: true,
        },
      },
      x: {
        ticks: {
          color: 'white',
        },
      },
    },

    // responsive: true,
    plugins: {
      datalabels: {
        color: 'white',
      },
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: t('dashboardDetail.cashflowEvolutionTitle'),
        color: 'white',
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.yLabel
          },
        },
      },
    },
  }

  const isInitialMount = useRef(true)
  const chartRef = useRef(null)
  const [structeredData, setStructuredData] = useState({
    labels: [1, 2, 3, 4],
    datasets: [
      {
        type: 'line',
        label: t('dashboardDetail.cashflow'),
        borderColor: 'purple',
        borderWidth: 3,
        fill: false,
        data: [800, 1500, 2200, 3400],
      },
      {
        type: 'line',
        label: t('dashboardDetail.cumulative'),
        borderColor: 'pink',
        borderWidth: 3,
        fill: false,
        data: [800, 2300, 4500, 7900],
      },
      {
        type: 'bar',
        label: t('dashboardDetail.revenue'),
        backgroundColor: ['#6087cd'],
        borderColor: ['#6087cd'],
        // backgroundColor: 'rgb(75, 192, 192)',
        data: [9800, 11000, 12200, 13400],
        // borderColor: 'white',
        color: '#fff',
        borderWidth: 2,
      },
      {
        type: 'bar',
        label: t('dashboardDetail.expense'),
        color: 'white',
        backgroundColor: ['#295a9c'],
        borderColor: ['#6087cd'],
        data: [9000, 9500, 10000, 10000],
      },
    ],
  })

  useEffect(() => {
    let revenus = []
    let depenses = []
    let cashflow = []
    let cf = []

    if (isInitialMount.current) {
      isInitialMount.current = false
    } else {
      data &&
        data.data &&
        data.data.map((v, i) => {
          revenus.push(deviseCal(v.revenus, siteDevise.devise.to_eur))
          depenses.push(deviseCal(v.depenses, siteDevise.devise.to_eur))
          cashflow.push(deviseCal(v.cashflow, siteDevise.devise.to_eur))
          cf.push(v.cf)
          return ''
        })

      setStructuredData({
        labels: [...data.yearMonths],
        datasets: [
          {
            type: 'line',
            label: t('dashboardDetail.cashflow'),
            borderColor: 'purple',
            borderWidth: 3,
            fill: false,
            data: [...cashflow],
          },
          {
            type: 'line',
            label: t('dashboardDetail.cumulative'),
            borderColor: 'pink',
            borderWidth: 3,
            fill: false,
            data: [...cf],
          },
          {
            type: 'bar',
            label: t('dashboardDetail.revenue'),
            backgroundColor: ['#6087cd'],
            borderColor: ['#6087cd'],
            // backgroundColor: 'rgb(75, 192, 192)',
            data: [...revenus],
            // borderColor: 'white',
            color: '#fff',
            borderWidth: 2,
          },
          {
            type: 'bar',
            label: t('dashboardDetail.expense'),
            color: 'white',
            backgroundColor: ['#295a9c'],
            borderColor: ['#6087cd'],
            data: [...depenses],
          },
        ],
      })
    }
  }, [data, siteDevise])
  return (
    <>
      {Object.keys(data).length > 0 && (
        <Chart
          data={structeredData}
          ref={chartRef}
          style={{
            height: '500px',
            background: '#001b42',
            borderRadius: '5px',
          }}
          options={optionsbar}
        />
      )}
    </>
  )
}

export default LineBarGraph
